import type { ExtensionCatalogueItem, OrganisationLibraryItem } from "@zworks/console-contracts";

/** The kind of an extension version, as the Marketplace shows it. */
export type ExtensionKind = OrganisationLibraryItem["kind"];

/** The lifecycle state of an extension version. */
export type ExtensionState = OrganisationLibraryItem["state"];

/** The status the catalogue declared for a pack at import, taken from the contract. */
export type PackStatus = NonNullable<ExtensionCatalogueItem["packStatus"]>;

export const kindLabels: Record<ExtensionKind, string> = {
  activity: "Activity",
  skill: "Skill",
  pack: "Pack",
};

/** Status is always a labelled badge, so the meaning never rests on colour alone. */
export const stateBadges: Record<
  ExtensionState,
  { label: string; variant: "success" | "info" | "danger" }
> = {
  published: { label: "Published", variant: "success" },
  approved: { label: "Approved", variant: "info" },
  submitted: { label: "In review", variant: "info" },
  evaluating: { label: "In review", variant: "info" },
  rejected: { label: "Rejected", variant: "danger" },
  withdrawn: { label: "Revoked", variant: "danger" },
};

/**
 * The pack's declared status, labelled. A version published through the marketplace
 * declared none, so it has no badge rather than an invented one.
 */
export const packStatusBadges: Record<
  PackStatus,
  { label: string; variant: "success" | "info" | "danger" }
> = {
  enabled: { label: "Enabled", variant: "success" },
  trial: { label: "Trial", variant: "info" },
  disabled: { label: "Disabled", variant: "danger" },
};
